import { DataSecurityAccessAnomalyAlert } from '@types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';
import { DynamicQueryParams, KeyPaginationQueryParams, PaginatedResource } from '@sonar-software/sonar-ts-types';

export type GetDataSecurityAccessAnomalyAlertsRequest = KeyPaginationQueryParams & DynamicQueryParams;

export type GetDataSecurityAccessAnomalyAlertsResponse = PaginatedResource<DataSecurityAccessAnomalyAlert>;

export const getDataSecurityAccessAnomalyAlerts =
	createGetEndpoint<GetDataSecurityAccessAnomalyAlertsRequest, GetDataSecurityAccessAnomalyAlertsResponse>(
		(request) => `/api/v3/data-security/alerts/access-anomaly?${getQueryString(request)}`
	);
